// extracted by mini-css-extract-plugin
export default {"panel":"AddWebGroup_panel__H6PUu","panel_body":"AddWebGroup_panel_body__RCxiz","radio":"AddWebGroup_radio__UqnUY"};